import React from 'react';
import { I18n as I } from 'react-redux-i18n';
import {
  LoaderOverlay,
  FormField,
  isNullOrWhitespace,
  isNumber,
  isPositiveNumber,
  isString,
} from 'vdlib';
import Portlet from 'components/layout/Portlet';
import { formatCreationData, useAuctionFields } from './auction-form-utils';

const validate = (key, value, fields, data) => {
  var excludeFields = ['InsuranceID', 'CountryID', 'RegionID'];

  const validationMessages = key ? { [key]: null } : {};

  if (isNullOrWhitespace(key)) {
    const fieldsToValidate = fields.filter(
      f => excludeFields.indexOf(f.name) < 0
    );

    for (var field of fieldsToValidate) {
      const fieldValue = data[field.name];
      if (field.name === 'VehicleDoors') {
        const numDoors = parseInt(fieldValue);
        if (!isPositiveNumber(numDoors, true))
          validationMessages[field.name] = I.t('FIELD_POSITIVE_NUMBER');
        else if (numDoors === 1)
          validationMessages[field.name] = I.t('FIELD_DOORS_CANNOT_BE_ONE');
      } else if (isNumber(fieldValue)) {
        if (!isPositiveNumber(fieldValue))
          validationMessages[field.name] = I.t('CHOOSE_VALUE');
      } else if (isString(fieldValue)) {
        if (isNullOrWhitespace(fieldValue))
          validationMessages[field.name] = I.t('FIELD_CANNOT_BE_EMPTY');
      }
    }
  } else {
    if (isNumber(value)) {
      if (!isPositiveNumber(value))
        validationMessages[key] = I.t('CHOOSE_VALUE');
    } else if (isString(value)) {
      if (isNullOrWhitespace(value))
        validationMessages[key] = I.t('FIELD_CANNOT_BE_EMPTY');
    }
  }

  return validationMessages;
};

const EditAuction = props => {
  const {
    auction,
    auctionEdited,
    editError,
    editingAuction,
    fetchAuction,
    onClearEditAuction,
    onEdit,
    router: {
      location: { pathname },
      push,
    },
    party,
  } = props;

  const {
    fields,
    formData,
    setValidationMessages,
    validationMessages,
  } = useAuctionFields(props, validate);

  // Reset data when auction uploaded
  React.useEffect(() => {
    if (auctionEdited) push({ pathname: pathname.replace('/edit', '') });
  }, [auctionEdited]); // eslint-disable-line

  const handleFormSubmit = React.useCallback(
    e => {
      if (e.preventDefault) e.preventDefault();

      const validationResult = validate(null, null, fields, formData);

      if (Object.keys(validationResult).length > 0)
        setValidationMessages(validationResult);
      else onEdit(...formatCreationData(formData, auction));

      return false;
    },
    [auction, fields, formData, onEdit, setValidationMessages]
  );

  React.useEffect(() => {
    if (!auction) fetchAuction();

    return () => {
      onClearEditAuction();
    };
  }, []); //eslint-disable-line

  const globalValidationMessage = validationMessages._global;

  return (
    <div>
      {editError && (
        <div className="row alert alert-danger">{editError.message}</div>
      )}
      <form action="#" onSubmit={handleFormSubmit} className="form-horizontal">
        <LoaderOverlay loading={!auction || editingAuction} />
        <div className="form-body">
          {auction && (
            <Portlet
              bodyClassName="row"
              title={I.t('FOLDER_C')}
              titleColorClass="font-grey-salsa"
            >
              {fields.map(f => (
                <FormField
                  key={f.name}
                  field={f}
                  value={formData[f.name]}
                  validationMessage={validationMessages[f.name]}
                />
              ))}
            </Portlet>
          )}
        </div>
        <div className="row form-actions mb">
          <div className="col-md-12">
            <button type="submit" className="float-right btn btn-sm green">
              {I.t('EDIT')}
            </button>
          </div>
        </div>
        {!!globalValidationMessage && (
          <div className="row alert alert-danger">
            {globalValidationMessage}
          </div>
        )}
      </form>
    </div>
  );
};

export default EditAuction;
